import { Outlet } from 'react-router-dom';
import { Footer, Header } from './components';
import { ScrollToTopButton } from 'components/ui';

export default function MainLayout() {
  return (
    <>
      {/* Topbar */}
      {/* <TopBar /> */}
      <Header />

      {/* Navbar */}
      {/* <NavBar /> */}

      {/* Page Content */}
      <Outlet />

      {/* Footer */}
      <Footer />

      {/* Floating Chat */}
      {/* <FloatingChatButton /> */}
      <ScrollToTopButton showAfter={250} />
    </>
  );
}
